
import Rotas from "./router";

import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import GlobalAlertas from "./components/AlertaGlobal/GlobalAlertas.jsx";

const queryClient = new QueryClient();

/* ======================================================
   ROTAS QUE PRECISAM DE SCROLL
====================================================== */

const ROTAS_COM_SCROLL = [
  "/relatorio/relatorio-notificacao",
  "/relatorio/produtividade",
  "/relatorio/motorista",
  "/relatorio/posicao",
  "/maps/editar-notificacao",
  "/maps/cadastro-notificacao",
];

/* ======================================================
   APP
====================================================== */

function App() {
  const location = useLocation();

  const usuarioLogado =
    localStorage.getItem("id") ||
    localStorage.getItem("clientID");

  const mostrarAlertas =
    location.pathname !== "/" && !!usuarioLogado;

  const precisaScroll = ROTAS_COM_SCROLL.some(
    (rota) =>
      location.pathname === rota ||
      location.pathname.startsWith(`${rota}/`)
  );

  /* ======================================================
     SWEETALERT2 — CONTROLE GLOBAL DO SCROLL
  ====================================================== */

  useEffect(() => {
    const body = document.body;

    const corrigirScrollSwal = () => {
      const swalAberto =
        body.classList.contains("swal2-shown");

      if (!swalAberto) return;

      // Impede a compensação lateral do SweetAlert2
      if (body.style.paddingRight !== "0px") {
        body.style.setProperty(
          "padding-right",
          "0px",
          "important"
        );
      }

      if (body.style.marginRight !== "0px") {
        body.style.setProperty(
          "margin-right",
          "0px",
          "important"
        );
      }
    };

    const observer = new MutationObserver(
      corrigirScrollSwal
    );

    observer.observe(body, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    // Verifica se já existe algum alerta aberto
    corrigirScrollSwal();

    return () => {
      observer.disconnect();

      body.style.removeProperty("padding-right");
      body.style.removeProperty("margin-right");
    };
  }, []);

  /* ======================================================
     AVISO DE ZOOM
  ====================================================== */

  useEffect(() => {
    const usuarioAtual =
      localStorage.getItem("id") ||
      localStorage.getItem("clientID");

    if (!usuarioAtual) return;
    if (location.pathname === "/") return;

    if (document.getElementById("zoom-aviso")) return;

    function detectarZoom() {
      const ratio1 = window.devicePixelRatio || 1;
      const ratio2 =
        window.screen.width / window.innerWidth;

      return Math.round(
        Math.max(ratio1, ratio2) * 100
      );
    }

    const zoom = detectarZoom();

    localStorage.setItem("zoomDetectado", zoom);

    if (
      localStorage.getItem("zoomAvisoOculto") === "true"
    ) {
      return;
    }

    const aviso = document.createElement("div");

    aviso.id = "zoom-aviso";

    aviso.innerHTML = `
      <div style="
        display:flex;
        flex-direction:column;
        gap:14px;
        font-family:sans-serif;
      ">
        <div style="
          display:flex;
          align-items:center;
          gap:8px;
        ">
          <span style="font-size:18px;">⚠️</span>

          <strong style="font-size:16px;">
            Ajuste de Visualização
          </strong>
        </div>

        <span style="
          color:#cfcfcf;
          line-height:1.5;
        ">
          Para uma melhor experiência de uso, ajuste o zoom
          da página conforme necessário. Em alguns dispositivos,
          o zoom padrão pode causar desalinhamentos na tela.
        </span>

        <div style="
          background:#2a2a2a;
          padding:12px;
          border-radius:8px;
          line-height:1.6;
        ">
          <b>Como ajustar o zoom:</b><br/>
          🖱️ Segure <b>CTRL</b> e utilize o <b>scroll do mouse</b><br/>
          ➖ Para diminuir, pressione <b>CTRL + -</b><br/>
          ➕ Para aumentar, pressione <b>CTRL + +</b><br/>
          🎯 Recomendamos utilizar entre <b>90%</b> e <b>100%</b>
        </div>

        <label style="
          display:flex;
          align-items:center;
          gap:8px;
          cursor:pointer;
        ">
          <input type="checkbox" id="naoMostrarCheck" />
          Não mostrar novamente
        </label>

        <button id="entendiBtn" style="
          background:linear-gradient(135deg,#4CAF50,#2e7d32);
          border:none;
          color:white;
          padding:10px;
          border-radius:8px;
          cursor:pointer;
          font-weight:bold;
        ">
          Entendi 👍
        </button>
      </div>
    `;

    Object.assign(aviso.style, {
      position: "fixed",
      top: "20px",
      right: "-350px",
      background: "rgba(30,30,30,0.95)",
      color: "#fff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
      zIndex: "9999",
      width: "280px",
      transition: "all 0.4s ease",
    });

    document.body.appendChild(aviso);

    const entrada = setTimeout(() => {
      aviso.style.right = "20px";
    }, 100);

    const btnOk = aviso.querySelector("#entendiBtn");
    const check = aviso.querySelector("#naoMostrarCheck");

    if (btnOk) {
      btnOk.onclick = () => {
        localStorage.setItem(
          "zoomAvisoOculto",
          check?.checked ? "true" : "false"
        );

        aviso.style.right = "-350px";

        setTimeout(() => aviso.remove(), 300);
      };
    }

    return () => {
      clearTimeout(entrada);
      document.getElementById("zoom-aviso")?.remove();
    };
  }, [location.pathname]);

  /* ======================================================
     RENDERIZAÇÃO
  ====================================================== */

  return (
    <QueryClientProvider client={queryClient}>
      {mostrarAlertas && <GlobalAlertas />}

      <div
        className={
          precisaScroll
            ? "app-route-scroll"
            : "app-route-fixed"
        }
      >
        <Rotas />
      </div>
    </QueryClientProvider>
  );
}

export default App;
